<template>
  <div v-if="loaded">
    <d-row
      v-for="(discount, index) of discounts"
      :key="'manufacturer-discount-item-' + index"
      :class="{'my-4': true, 'mt-4': index === 0}">
      <d-col sm="7" md="8" lg="9">
        <validation-provider
          :name="'manufacturer-discount-item-' + index + '-name'"
          v-slot="{ errors }">
          <div
            :class="{
              'form-control': true,
              'is-select': true,
              'is-invalid': errors.length,
              'vs-wrap-text': true
            }">
            <v-select
              :disabled="disabled"
              :options="allManufacturers"
              v-model="discounts[index].id"
              placeholder="Wybierz producenta"
              :reduce="(manufacturer) => manufacturer.id"
              :selectable="option => checkIfSelectable(option.id)"
              label="name">
            </v-select>
          </div>
          <div class="invalid-feedback">
            {{ errors[0] }}
          </div>
        </validation-provider>
      </d-col>
      <d-col sm="3" md="3" lg="2" class="mt-3 mt-sm-0">
        <validation-provider
          type="number"
          :name="'manufacturer-discount-item-' + index + '-value'"
          rules="max_value:100|min_value:0"
          v-slot="{ errors }">
          <d-input-group append="%">
            <d-input
              class="text-right"
              :disabled="disabled"
              min="0"
              max="100"
              step="1"
              type="number"
              :state="errors.length ? 'invalid' : null"
              v-model="discounts[index].discount"/>
          </d-input-group>
          <div class="invalid-feedback">
            {{ errors[0] }}
          </div>
        </validation-provider>
      </d-col>
      <d-col sm="2" md="1" class="mt-3 mt-sm-0">
        <d-button
          theme="danger"
          style="float: right;"
          @click.prevent="removeDiscount(index)"
          title="Usuń">
          <i class="material-icons">delete</i>
        </d-button>
      </d-col>
    </d-row>
  </div>
</template>

<script>

export default {
  name: 'manufacturer-discount',
  props: [
    'disabled',
    'allManufacturers',
    'currentManufacturers'
  ],
  data () {
    return {
      discounts: [],
      loaded: false
    }
  },
  mounted () {
    this.discounts = JSON.parse(JSON.stringify(this.currentManufacturers));
    this.loaded = true;
  },
  methods: {
    addDiscount () {
      this.discounts.push({
        id: null,
        discount: 0
      });
    },
    getDiscounts() {
      return this.discounts.filter(ele => ele.id !== null);
    },
    getDiscountsAmount() {
      return this.discounts.length
    },
    removeDiscount (index) {
      this.discounts.splice(index, 1);
    },
    checkIfSelectable(optionID) {
      let selectedManufacturers = this.discounts.map(discount => discount.id);
      return selectedManufacturers.indexOf(optionID) < 0;
    }
  }
}

</script>
